import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const createNotification = async (body: any, token: string) => {
    try {
        const response = await axios.post(api_url + `admin/notifications`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getNotifications = async (token: string) => {
    try {
        const response = await axios.get(api_url + `admin/notifications`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteNotification = async (notificationId: string, userId: string, userType: string, token: string) => {
    try {
        const response = await axios.delete(api_url + `admin/notifications/${notificationId}?userId=${userId}&userType=${userType}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getNotificationById = async (notificationId: string, token: string) => {
    try {
        const response = await axios.get(api_url + `admin/notifications/${notificationId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateNotification = async (body: any, token: string) => {
    try {
        const response = await axios.put(api_url + `admin/notifications`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getNotificationCount = async (userId: string, token: string) => {
    try {
        const response = await axios.get(api_url + `user/notifications/${userId}/count`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const markNotificationAsRead = async (body: any, token: string) => {
    try {
        const response = await axios.put(api_url + `user/notifications/read-status`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getUserNotifications = async (userId: string, isRead: boolean, token: string) => {
    try {
        const response = await axios.get(api_url + `user/notifications/${userId}?isRead=${isRead}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getAllUserNotifications = async (userId: string, token: string) => {
    try {
        const response = await axios.get(api_url + `user/notifications/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}